import type { CameraState, StageStateV1 } from '@shotstead/contracts'
import { validateStageStateV1 } from '@shotstead/contracts'

export const SHOTSTEAD_STAGE_STORAGE_KEY = 'shotstead.stage-state.v1'

export function cloneStageState(stage: StageStateV1): StageStateV1 {
  return structuredClone(stage)
}

export function serializeStageState(stage: StageStateV1): string {
  return JSON.stringify(stage)
}

export function deserializeStageState(serialized: string): StageStateV1 {
  const parsed: unknown = JSON.parse(serialized)
  const result = validateStageStateV1(parsed)

  if (!result.valid) {
    throw new Error(`Invalid StageState: ${result.errors.join('; ')}`)
  }

  return result.value
}

export function replaceCameraState(stage: StageStateV1, camera: CameraState): StageStateV1 {
  return {
    ...stage,
    camera: structuredClone(camera),
  }
}

export function patchCameraState(
  stage: StageStateV1,
  patch: Partial<Pick<CameraState, 'target_ref' | 'fov_degrees' | 'movement'>> & {
    transform?: Partial<CameraState['transform']>
  },
): StageStateV1 {
  const nextCamera: CameraState = {
    ...stage.camera,
    ...patch,
    transform: {
      ...stage.camera.transform,
      ...(patch.transform ?? {}),
    },
  }

  return replaceCameraState(stage, nextCamera)
}

export function sameStageExceptCamera(before: StageStateV1, after: StageStateV1): boolean {
  const { camera: _beforeCamera, ...beforeRest } = before
  const { camera: _afterCamera, ...afterRest } = after
  return JSON.stringify(beforeRest) === JSON.stringify(afterRest)
}

export {
  InMemoryStageRepository,
  SHOTSTEAD_STAGE_HISTORY_STORAGE_KEY,
  StageVersionConflictError,
  deserializeStageHistory,
  diffStageStates,
  sameStageContinuityState,
  serializeStageHistory,
} from './stage-repository'
export type { StageDiff } from './stage-repository'
